import React, { useState } from "react";
import { Link } from "react-router-dom";
import ProgressBar from "react-bootstrap/ProgressBar";
import Calculator from "../../Common/Calculator";

const Hero = () => {
  const options = [
    {
      label: "USDT",
      value: "USDT",
      image: "/images/usdt-removebg-preview.png",
    },
    { label: "BNB", value: "BNB", image: "/images/bnb-bnb-logo.png" },
    {
      label: "WETH",
      value: "WETH",
      image: "/images/ethereum-logo-EC6CDBA45B-seeklogo.com.png",
    },
  ];
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(options[0]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  return (
    <>
      <section className="Hero" id="main-comp" >
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-6">
              <div className="hero-content">
                <div class="text-animate">
                  <span>
                    $POCKET is the token for Pocket Ventures stakeholders and
                    community-minded investors interested in social good.
                  </span>
                </div>
                <h1>Interested in community health and wealth?</h1>
                <p>
                  In this social impact crypto VC ecosystem, your tokens
                  influence investments in community-focused startups. You share
                  in the collective the joy of impact investing.
                </p>
                {/* <div className="btns">
                  <Link className="explore" to="">
                    Join Presale
                  </Link>
                </div> */}
              </div>
            </div>
            <div className="offset-lg-1 col-lg-5 col-md-12 col-sm-12">
              <Calculator />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Hero;
